  /* 国际化zh_tw */

module.exports = {
    base: {
        'nomore': 'No More', // 沒有更多了
        'sure': 'OK', // 确定
        'not_desc': 'No Fiscription' // 暂无描述
    },
    common: {
        'get_code': 'Get Verification Code', // 获取验证码
        'onsale_status': 'Product Invalid', //
        's_regain': 's Refetch Later', //
        'regain': 'Get Again', // 重新获取
        'cancel': 'Cancel', // 取消
        'select': 'Choose', // 选取
        'empty_item': 'No Content', // 暂无内容
        'load_fail': 'Loading Fail', // 加载失败
        'tabbar_my_name': 'My' //
    },
    tabbar: {
        'home': 'Home', // 首页
        'category': 'Category', // 分类
        'cart': 'Cart', // 购物车
        'profile': 'My', // 我的
        'service': 'skype' // 客服
    },
    address: {
        'name': 'Consignee Name', //
        'name_placeholder': 'Consignee Name', //
        'mobile': 'Mobile', //
        'mobile_placeholder': 'Personal mobile phone', //
		'email': 'Email',
		'email_placeholder': 'Input E-mail',
        'region': 'Region', //
        'region_placeholder': 'City , Area , Street', //
        'address': 'Address', //
        'address_placeholder': 'Detail Address', //
        'zip': 'Zip Code', //
        'zip_placeholder': 'Zip Code', //
        'name_empty': 'Consignee Name', //
        'name_less': '2-50 Character Limit', //
        'mobile_empty': 'Please enter a Mobile Number!', //
        'mobile_less': 'Please Fill In Correct Form Ff The Mobile Number', //
        'region_empty': 'Select Region', //
        'address_empty': 'Detail Adress Information', //
        'zip_empty': 'Zip Code', //
        'save_use': 'Save And Use', //
        'save': 'Save', //
        'add': 'Add New Address ', //
        'edit': 'Change Delivery Address', //
        'delete': 'Delete',
        'list_title': 'Shipping Address', //
        'list_title_item': 'Administer', //
        'default': 'Default', //
        'list_default': 'Default Address', //
        'list_edit': 'Edit', //
        'list_delete': 'Delete', //
        'manage_title': 'Edit Shipping Address', //
        'manage_empty': 'No Shipping Address', //
        'manage_add': 'Add Shipping Address', //
        'confirm_del': 'Sure to Delete This Address?', //
        'confirm_del_title': 'Confirm The Deletion', //
        'region_select': 'Select Region', //
        'region_cancel': 'Cancel', //
        'region_confirm': 'Confirmed' //
    },
    auth: {
        'retrieve': 'Find Password', // 密码找回
        'mobile': 'Mobile Number', //
        'email': 'Email Address', //
        'go_signin': 'Sign In', //
        'sure': 'Confirmed', //
        'signin': 'Sign In', // 登录
        'signup': 'Signup', // 注册
        'fast_signup': 'Signup', // 快速注册
        'email_signup': 'Email Register', //
        'agree': 'Agree To Register', //
        'agreement': '《User Agreement》', //
        'signup_succ': 'Registered Successfully', //
        'signup_agreement': 'Registration Agreement' //
    },
	auth_signin: {
		'username_placeholder': 'Uesername/E-mail', // 用户名/邮箱/手机号
		'password_placeholder': 'Password', // 请输入密码
		'forget': 'Forget Password？', // 忘记密码？
		'third_party': 'Third Party Login', //
		'wechat': 'wechat', // 微信
		'passport_empty': 'Password', // 请输入密码
		'passport_less': "Shound't Less Than Six Bit", // 至少输入6位密码
		'expire': 'Login Expired', // 登录过期
		'username_empty': 'Input Uesername/E-mail' // 请输入用户名
	},
	auth_bind: {
		'mobile': 'Bind Mobile', // 绑定手机
		'code_placeholder': 'Enter Phone Verification Code', //
		'username_placeholder': 'Input Mobile Number', // 请输入手机号
		'passport_placeholder': 'Set Password', // 设置密码
		'confirmPassword_placeholder': 'Confirm Password', // 确认密码
		'tips': '6-20 Numbers/Letters/Symbol', //
		'finish': 'Finish', // 完成
		'mobile_less': 'Enter The Correct Phone Number Format', //
		'code_empty': 'Enter Verification Code', //
		'code_less': 'Enter 6 Verification Code', //
		'password_empty': ' Enter Password', //
		'password_less': 'Enter 6-20 Characters Password', //
		'confirmPassword_empty': 'Enter Confirmed Password', //
		'passport_error': 'Wrong Confirmed Password' //
	},
	auth_email: {
		'confirm_tips': 'Password Modify Link Has Sent To', // 密码修改链接已发送至
		'email_placeholder': 'Input E-mail', // 请输入您的邮箱
		'tips': "We'll Sent Password Modify Link to Your Bind E-mail", // 我们将发送密码修改链接到您绑定的邮箱
		'send': 'Send E-mail', // 发送邮件
		'empty': 'Input E-mail', // 请输入邮箱
		'validator_error': 'Wrong E-mail Address', // 邮箱地址不正确
		'username_placeholder': 'Usename', // 用户名
		'username_tips': 'Enter A 3-25 Character Username', //
		'passport_tips': '6-20 Numbers/Letters/Symbol', //
		'signup_email_placeholder': 'E-mail Address', // 邮箱地址
		'email_tips': 'Input E-mail', // 请输入邮箱地址
		'username_empty': 'Enter A 3-25 Character Username', //
		'password_empty': 'Input Password', // 请输入密码
		'password_less': 'Enter 6-20 Characters Password' //
	},
    auth_mobile: {
        'retrieve_succ': 'Your Password Has Been Successfully Modified'
    },
    balance: {
        'usable_title': 'Available Funds', // Available Funds
        'desc': 'Available Funds（$）', //
        'withdraw': 'Withdrawal', //
        'withdraw_history': 'Withdrawal Record', // //
        'withdraw_show': 'Check The Funds Detail', //
        'history_title': 'Financial Details', //
        'history_empty': 'No Details', //
        'history_all': 'All', //
        'history_income': 'Income', //
        'history_expend': 'Expend' //
    },
    withdraw: {
        'history_title': 'Withdrawal Record', //
        'history_empty': 'No Record', //
        'history_confirm': 'Cancel The Withdrawal?', //
        'history_confirm_title': 'Confirm To Cancel', //
        'title': 'Withdraw', //
        'succ_title': 'Withdrawal Record', //
        'succ_desc': 'Check The Funds Detail', //
        'amount': 'Withdrawal Amount', //
        'remarks': 'Remarks', //
        'btn_finish': 'Complete', //
        'subtitle': 'Withdrawal Amount', //
        'tips': 'Exceed Withdrawal Limition', //
        'mentioning_balances': 'Available Balance $', //
        'all': 'All Withdrawal', //
        'remark_placeholder': 'Enter Bank Name And Bank Account', //
        'btn_submit': 'Submit', //
        'amount_empty': 'Enter Withdrawal Amount', //
        'remark_empty': 'Enter Bank Name And Bank Account', //
        'item_title': 'Seller Remarks', //
        'item_amount': 'Withdrawal Amount', //
        'item_time': 'Application Date', //
        'item_remark': 'Member Remarks', //
        'item_cancel': 'Cancel The Withdrawal', //
        'wait': 'Pending', //
        'finish': 'Withdrawal Success', //
        'cancel': 'Cancelled', //
        'failed': 'Withdrawal Fail' //
    },
    bonus: {
       'list_title': 'Recommendation', //
       'recommended': 'Recommended', //
       'amount': 'Divided To', //
       'rule': 'Proportion Rule', //
       'balance': 'Available Funds', //
       'recommend': ' My Recommend Member', //
       'order_empty': 'No Recommend Order', //
       'recommend_rank': 'Level', //
       'recommend_amount': 'Number Of People', //
       'recommend_score': 'Points Divided To', //
       'recommend_price': 'Cash Divided To', //
       'recommend_empty': 'No Recommendatoin', //
       'order_sn': 'Order No.', //
       'cash': 'Cash', //
       'wait': 'In Review', //
       'finish': 'Divided Into', //
       'cancel': 'Cancelled', //
       'revoke': 'Undone', //
       'type_signup': '推荐注册分成', //
       'type_order': '推荐订单分成', //
       'score_signup': '等级积分', //
       'score_order': '消费积分', //
       'my_qrcode': '我的推广二维码', //
       'qr_desc': '扫描二维码，关注我的小店', //
       'qr_share': '分享小店', //
       'qr_copy': '复制链接', //
       'qr_share_title': '推荐分成', //
       'qr_share_desc': '点击链接关注小店成为推广员，拿取更多分成', //
       'qr_link': '已为您生成推广链接', //
       'btn_confirm': '确认' //
    },
    cart: {
        'title': 'Cart', // 购物车
        'edit': 'Edit', // 编辑
        'finish': 'Finish', // 完成
        'select_all': 'Select All', // 全选
        'total': 'Total:', // 合计
        'delete': 'Delete', // 删除
        'checkout': 'Checkout', // 结算
        'empty': "There's nothing in your shopping cart", // 您的购物车还是空的
        'no_signup': 'Log in to check shopping cart', // 登录后即可查看购物车中的商品
        'gohome': 'To Homepage', // 随便逛逛
        'gosignin': 'User Sign In', // 去登录
        'sold_out': 'Sold Out', // 已售罄
        'only_left': 'Only Left', // 仅剩
        'piece': '1Piece', // 件
        'promos_tag': 'Promote', // 促销
        'delete_empty': 'No Items To Delete', // 当前没有可删除的商品
        'no_reduce': "It can't be less", //
        'out_of_stock': 'Stock Insufficient', //
        'promos': 'Satisfied', //
        'un_promos': 'Unsatisfied', //
        'order_promos': 'Promotion Order' //
    },
    cashgift: {
        'list_title': 'My Coupon', //
        'list_empty': 'No Coupons', //
        'unuse': 'Unused', //
        'used': 'Used', //
        'expired': 'Expored', //
        'bonus_sn_placeholder': 'Enter Coupon Series Number', //
        'bonus_add': 'Add Coupon', //
        'bonus_sn_empty': 'Enter 10 Series Numbers', //
        'bonus_add_succ': 'Add Coupon Success', //
        'no_use_bonus': 'Do Not Use Coupon', //
        'full': 'Up To', //
        'can_use': 'Can Use' //
    },
    coupon: {
		'list_title': 'My Coupon',
		'list_empty': 'No Coupons',
		'full': 'Up To',
		'can_use': 'Can Use',
		'unuse': 'Unused',
		'used': 'Used',
		'expired': 'Expored',
		'redbag_title': 'My Coupon',
		'can_use_coupon': 'Can Use Coupons',
		'no_use_coupon': 'Do Not Use Coupon',
		'redbag_empty': 'No Coupons',
		'piece': ' '
	},
    category: {
        'title': 'Category', // 分类
        'all': 'All', // 全部
		'enter': 'enter',
		'column': 'column'
    },
    checkout: {
        'title': ' Confirm Order', //
        'title_shipping': 'Delivery Method', //
        'title_invoice': 'Invoice Type', //
        'title_cashgif': 'Use Coupon', //
        'title_product_price': 'Product Price', //
        'title_tax_price': 'Amount Of Invoice Tax', //
        'title_shipping_price': 'Shipping Price', //
        'total_price': 'Actual Payment', //
        // 'total_price_tips': '( Price Exclude Tax )', //
        'btn_checkout': 'Submit Order', //
        'shipping_empty': 'Please Select Delivery Method', //
        'consignee_empty': 'Please Fill In The Delivery Address', //
        'cashgift_unuse': 'Unused', //
        'cashgift_nouse': 'Nouse', //
        'cashgift_tips': 'One Selected', //
        'cashgift_canuse': 'Can Use', //
        'no_invoice': 'No Invoice', //
        'invoice_type_empty': 'Please Select Invoice Type', //
        'no_shipping_price': 'No Shipping Price', //
        'goback_mess': 'The Goods Wait For No One. Think Twice About It.', //
        'goback_cancel_text': 'Leave', //
        'goback_confirm_text': 'Think Again', //
        'invoice_header': 'Set Invoice Information', //
        'invoice_type_title': 'Invoice Type', //
        'invoice_tips': 'Afraid Of Losing Paper Invoices? Try E-invoicing!', //
        'invoice_title': 'Invoice Payable To', //
        'invoice_personal': 'Personal', //
        'invoice_content': 'Invoice Content', //
        'invoice_btn_submit': 'Make Sure', //
        'invoice_empty': 'Please Fill In The Complete Invoice Information', //
        'shipping_price': 'Shipping Price', //
        'goods_list_header': 'Goods List', //
        'total': 'total: ', //
        'piece': ' piece', //
        'score_header': 'Points Deduction', //
        'score_most': 'Most Available ', //
        'score': ' Points', //
        'deduct_from': 'Deduction Per Point $', //
        'rmb': ' Dollar', //
        'no_score': 'No Points', //
        'score_placeholder': 'Enter Points Here', //
        'delivery_time': 'Delivery Time', //
        'comment_title': 'Buyer Message', //
        'comment_placeholder': 'Optional: Description Of The Transaction (It Is Recommended To Fill In The Content That Has Been Agreed With The Seller), Leave message here if you have customize products requirements.', //
        'address_empty': ' You Have No Delivery Address. Click Here To Add.', // 您还没有收货地址，点击这里添加。
        'promos_preferential': 'Discounted Price', //
        'promos_cashgift': 'Coupon', //
        'promos_score': 'Points', //
        'promos_order_reduction': 'Order Promotion', //
        'promos_goods_reduction': 'Product Promotion', //
        'promos_coupon_reduction': 'Coupon', //
        'promos_combined_promos': 'Group Purchase', //
        'promos_transport_title': 'Shipping Price', //
        'tax_header': 'Tax Number', // 税号
        'tax_tips': 'To facilitate customs clearance', // 税号为什么要填写
        'import_duty': 'Tax charge', // 进口关税
        'price_tips': '「 Price Exclude Tax 」', //不含税价格!

        "coo": 'Require Certificate Of Origin (COO)', //需要原产地证书
        "coo_fee": 'COO Fee', //产地证书费用
        "yes": 'YES', //是
        "no": 'NO' //否
    },
    payment: {
        'header': 'Checkout Counter', //
		'paypal_cancel_header': 'Cancel Status',
		'order_succ': 'Order Submitted Successfully, Please Select Payment Method', //
        'total_price': 'Total', //
        'teegon_wechat': 'Teegon Cashier WeChat Pay', //
        'btn_pay': 'Pay Now', //
        'goback_mess': "It's Gone In The Blink Of An Eye. Are You Sure You Don't Want To Pay?", //
        'goback_cancel_text': 'Leave', //
        'goback_confirm_text': 'Think Again', //
        'code_empty': 'Please Select Payment Method', //
        'succed_header': 'Purchase Successfully', //
        'order_succed': 'Order Submitted Successfully', //
        'order_fail': 'Order Submitted Failed', //
        'exchange_order_succed': 'Congratulations. The Redemption Is Successful', //
        'exchange_order_fail': 'The Redemption Is Failed', //
        'order_detail': 'Order Details', //
		'exchange_order_cancel_succ': 'The Redemption Is Canceled',
		'exchange_order_cancel_fail': 'The Redemption Is Cancelling Failed',
		'order_cancel_succ': 'The Pay is Canceled',
		'order_cancel_fail': 'The Pay Is Cancelling Failed'
    },
    discount: {
        'header': 'Promotions',
        'empty': 'No Promotions Now',
        'range_0': 'All Products Are Available',
        'range_1': 'Some Categories Are Available',
        'range_2': 'Some Brands Are Available',
        'range_3': 'Some Products Are Available',
        'range_canuse': 'Available',
        'is_end': 'The Activity Is Over',
        'waiting': 'Coming soon',
        'is_waiting': 'The Activity Has Not Started',
        'list_empty': 'The Products List Is Empty Yet',
        'no_more': 'No More',
        'review_rate': 'High Review Rate',
        'sales_count': 'Sales Count',
        'surplus': 'Surplus',
        'day': 'Day',
        'hour': 'Hour',
        'minute': 'Minute',
        'second': 'Second'
    },
    promotions: {
        'no_more': 'No More',
        'endtime': 'To End Time',
        'day': 'Day',
        'hour': 'Hour',
        'minute': 'Minute',
        'second': 'Second'
    },
    home: {
        'goodproduct': 'Hot Recommend', // 热门推荐
        'hotproduct': 'Sales Ranking', // 销量排行
        'recentproduct': 'New Arrivals', // 新品上架
		'suitproducts': 'Suitproducts', // 组合商品
		'header_placeholder': 'What do You Want to Find？', // 想找什么？
        'menu_activity': 'Activities', // 优惠活动
        'menu_integralmall': 'Point Mall', // 积分商城
        'menu_order': 'Order', // 订单
        'menu_bonus': 'Coupons', // 红包
		'menu1': 'Exoskeleton Legged',
		'menu2': 'Coordinative Arm',
		'menu3': 'Gimbal Ladar',
		'menu4': 'Category',
		'menu5': 'My',
        'product_buy': 'Sold', // 人已购买
        'share_title': 'Recommend Share', //
        'share_desc': 'Click The Link To Follow The Store, Become A Promoter, And Get More Shares' //
    },
    integralmall: {
        'header': 'Point Mall', //
        'hotproduct': 'Hot', //
        'allproduct': 'All', //
        'no_more': 'No More Products', //
        'score': 'Points' //
    },
    message: {
        'header': 'Message Center', //
        'order': 'Order Message', //
        'notice': 'Notification Messages', //
        'empty': 'No Messages', //
        'no_message': 'You Have No Message Yet' //
    },
    order: {
        'header': 'My Order', //
        'empty': 'Your Order Is Empty', //
        'gohome': 'Go Around', //
        'copy': 'Copy', //
        'all': 'All', //
        'created': 'Unpaid', //
        'paid': 'Unshipped', //
        'status_cancelled': 'Cancelled', // 已取消
        'back_info': 'Transfer Information', // 转账信息
        'status_finished': 'Completed', // 已完成
        'status_deliveried': 'Completed', // 已完成
        'status_delivering': 'Shipping', // 配送中
        'nav_delivering': 'Shipped', //
        'nav_deliveried': 'Completed', //
        'comment_3': 'Good', //
        'comment_2': 'Medium', //
        'comment_1': 'Bad', //
        'sn': 'Order No.', //
        'total': 'Total', //
        'total_price': 'Total', //
        'product': 'Piece Product', //
        'shipping_price': 'Include Shipping Price', //
        'btn_cancel': 'Cancel Order', //
        'cancels': 'Cancel', //
        'cancels_finish': 'Completed', //
        'go_payment': 'Go To Payment', //
        'btn_track': 'Check Delivery', //
        'btn_confirm': 'Confirm Receipt', //
        'btn_comment': 'Evaluate And Show The Order', //
        'no_want': 'No longer want', //
        'no_payment': 'Unsuccessful Payment', //
        'no_price': 'Expensive Price', //
        'no_store': 'No Store', //
        'long_wait': 'Wait Too Long', //
        'confirm_title': 'Confirm Receipt', //
        'confirm_content': 'Do You Confirm Receipt?', //
        'cancel_reason_empty': 'Please Select A Reason For Cancellation', //
        'detail_header': 'Order Detail', //
        'detail_status_0': 'Waiting For Payment', //
        'detail_status_1': 'Unshipped', //
        'detail_status_2': 'Shipping', //
        'detail_status_3': 'Completed', //
        'detail_status_4': 'Completed', //
        'detail_status_5': 'Cancelled', //
        'detail_status_6': 'Distributing', //
        'detail_score': 'Points', //
        'detail_more': 'More', //
        'piece': 'Piece', //
        'add_time': 'Order Time', //
        'is_exchange_good_pay': 'Payment Method:Points Redemption', //
        'payment': 'Payment Method', //
        'shipping': 'Delivery Method', //
        'product_price': 'Total Product Price', //
        'tax_price': 'Amount Of Invoice Tax', //
        'detail_shipping_price': 'Shipping Costs', //
        'detail_total_price': 'Real Payment', //
        'copy_succed': 'Copy Successfully', //
        'no_shipping_price': 'No Shipping Price', //
        'track_header': 'Order Track', //
        'track_vendor_name': 'Source Of Transportation', //
        'trade_header': 'Trade Successful', //
        'trade_succed': 'Trade Successful, The Seller Will Receive Your Payment!', //
        'go_comment': 'Go Comment', //
        'go_detail': 'Order Detail', //
        'check_detail': 'Check Order', //
        'comment_header': 'Evaluate Product', //
        'comment_submit': 'Submit', //
        'comment_content': 'Please Enter Comment Here', //
        'comment_content_empty': 'Please Evaluate The Product', //
        'comment_succed': 'Comment Successfully', //
        'comment_succed_tips': 'Successful Product Comment, Thank You.', //
        'comment_gohome': 'Go Around Again' //
    },
    product: {
        'sort_default': 'Overall ranking', //
        'sort_price_asc': 'Price from low to high', //
        'sort_price_desc': 'Price from high to low', //
        'sort_credit_desc': 'Good Comment Ranking', //
        'sort_sale_desc': 'Sales Ranking', //
        'sort_date_desc': 'New products', //
        'product_tab': 'Product', // 商品
        'detail_tab': 'Detail', // 详情
        'evaluate_tab': 'Comments', //
		'parameter_tab': 'Spec', // 规格参数
        'videos_tab': 'Videos', // 视频
        'recom_tab': 'Recommended Configuration',
        'packing_tab': 'Packing List',
        'keyword_placeholder': 'Please Enter Keywords', //
        'keyword_empty': 'Please enter the keywords you want to search', //
        'sold_out': 'Sold Out', //
        'only_left': 'Only Left ', //
        'piece': 'Piece', // 件
        'self_support': 'Self Support', //
        'review_rate': 'Good Comment', //
        'sales_count': 'Sales Count', //
        'add_cart_succ': 'Add Cart Successfully', //
        'empty': 'No More Products', //
        'no_more': 'No More'
    },
    product_detail: {
        'total': 'All', //
        'good': 'Good', //
        'medium': 'Medium', //
        'bad': 'Bad', //
        'review': 'Evaluate', // 评价
        'add_cart': 'Add to Cart', // 加入购物车
        'fastbuy': 'Buy Now', // 立即购买
        'exchange': 'Exchange', // 立即兑换
        'not_stock': 'Sold Out, Sorry!', // 所选产品暂时无货，非常抱歉！
        'not_enough_score': 'Score Not Enough', // 积分不足
        'sure': 'OK', // 确定
        'properties_empty': 'Please Select Product Attributes', //
        'not_enough_stock': 'No Enough Stock', //
        'exchange_title': 'Confirm Exchange', //
        'exchange_message_1': 'Exchange Or Not', //
        'exchange_message_2': 'Exchange Points', //
        'cancel_btn': 'Cancel', // 取消
        'confirm_btn': 'Confirm', // 确认
        'wechat_config_title': 'Product Detail', // 商品详情
        'score': 'Points', // 积分
        'stock': 'Stock', // 库存
        'number': 'Number', // 数量
        'max_number': 'Commodities Reach The Limit Of Purchase Quantity Per Order', //
        'no_reduce': 'Cannot Reduce ', //
        'no_desc': 'No Detail', // 本商品暂无详情
        'infobuy_number_select': 'Choose Buy', // 请选择购买
        'infobuy_number': 'Number Catgory', // 数量分类
        'infobuy_selectd': 'Choosed', // 已选
        'infobuy_number_selectd': 'Choosed Num', // 已选数量
        'concat': 'Concat Customer', // 联系客服
        'current_day': 'Current_day', // 当天
        'next_day': 'Next_day', // 次日
        'month': 'Month', // 月
        'day': 'Day', // 日
        'like': 'Favor', // 点赞
        'promos_time_title': 'To End Time', // 距离活动结束时间
        'day_1': 'd', // 天
        'hour': 'h', // 时
        'minute': 'm', // 分
        'second': 's', // 秒
        'promos_info_title': 'Promotion Info', // 促销信息
        'info_header': 'Product Detail', // 商品详情
        'review_content_empty': 'No Comment Info', // 无评价信息
        'review_empty': 'No Comments', // 本商品暂无评价
        'recommend_show_all': 'Check All', // 查看全部
        'suit_goods_selected_empty': 'Please select all attributes of the selected product!',
        'parameter': 'Parameter'
    },
    profile: {
        'score': 'Points', // 积分
        'record_list': 'Points Record', // 积分记录
        'order_header': 'My Order List', // 我的订单
        'order_all': 'All Order List', // 查看全部订单
        'order_status_0': 'Unpaid', // 待付款
        'order_status_1': 'Unshipped', // 待发货
        'order_status_2': 'Shipped', // 待收货
        'order_status_3': 'Completed', // 完成
        'favourite_header': 'My Collected', // 我的收藏
        'address_header': 'Manage Address', // 管理收货地址
        'cashgift_header': 'My Coupons', // 我的红包
        'addcashgift_header': 'Add Coupons', // 添加红包
        'bonus_header': 'My Recommended', // 我的推荐
        'balance_header': 'My Cash', // 我的资金
        'help_header': 'Guidance', // 使用帮助
        'bonus_qr_header': 'My Promotional QR Code', // 我的推广二维码
        'nickname_title': 'Sign In/Signup', // 登录/注册
        'setting_header': 'Help Guide',
        'about': 'About Us',
        'contact': 'Contact Us',
        'Payment': 'Payment Guide',
        'help': 'Order Information',
        'Postsale': 'Postsale service',
        'warranty': 'Warranty Policy',
        'signout': 'Sign Out', // 退出登录
        'signout_confirm': 'Sign Out Sure', // 确认退出
        'info_header': 'Profile', // 个人资料
        'edit_nickname': 'Edit Nickname', // 修改昵称
        'gender': 'Gender', // 性别
        'edit_pwd': 'Edit Password', // 修改密码
        'male': 'Male', // 男
        'female': 'Female', // 女
        'secret': 'Keep Secret', // 保密
        'nickname_placeholder': 'Input Nickname', // 请输入昵称
        'nickname_empty': 'Please Enter 1-25 Words As Your Nickname', //
        'nickname_succ': 'Modification succeeded', // 修改昵称成功
        'oldpass_empty': 'The Current Password Cannot Be Empty', //
        'pass_less': 'Please Enter A Password Of 6-20 Characters', //
        'newpass_empty': 'New Password Cannot Be Empty', //
        'confirpass_empty': 'Please Enter The Confirmation Password', //
        'confirpass_false': 'The Confirmation Password Is Inconsistent With The Input Password', //
        'btn_save': 'Save', // 保存
        'add_header': 'Complete Information', //
        'skip': 'Skip', // 跳过
        'add_tips': 'With [*] Is Required', //
        'add_submit': 'Complete', //
        'placeholder': 'Please Fill In', //
        'add_succ': 'Perfect Information Success', //
        'product_empty': 'No Goods Available', //
        'gohome': 'Go Around', //
        'not_stock': 'Out Of Stock', //
        'only_left': 'Only Left ', //
        'piece': ' Piece', //
        'delete': 'Delete', //
        'confirm_del_title': 'Confirm Delete', //
        'confirm_del_mess': 'Do You Want to Remove This Product?', //
        'share': 'Share', //
        'share_refresh': 'Reload', //
        'share_to': 'Share To', //
        'share_wechat': 'Wecha', //
        'share_blog': 'Weibo', //
        'share_qq': 'QQ', //
        'share_cancel': 'Cancel', //
        'change_avatar': 'Change Avatar', //
        'change_avatar_placeholder': 'Please Select an Avatar', //
        'upload': 'Uploading...', //
        'image_type': 'The Picture Type Must Be One Of gif, jpeg, jpg, png, bmp' //
    },
    recommend: {
        'product': 'Related Products',
        'accessory': 'Related Collocation',
        'no_more': 'No More' // 没有更多了
    },
    score: {
        'header': 'My Points',
        'can_use': 'Currently Available Points',
        'all': 'All',
        'income': 'Income',
        'expend': 'Expend',
        'empty': 'No Points Record Yet',
        'exchange_succ': 'Redeem Points Successfully',
        'rule_header': 'Points Rule',
        'have_score': 'Get Points',
        'expend_score': 'Pay Points',
        'item_score': 'Points',
        'platform': 'Applicable Platform',
        'to_exchange': 'Exchange Now',
        'confirm_use': 'Confirm To Use',
        'exchange_score': 'Points,Exchange',
        'coupon': 'Coupon?',
        'confirm_btn': 'Confirm',
		'tip_message': 'The Points To Be Paid Will Be Automatically Added To The Total Points After The Payment Is Successful!',
		'tip_btn_text': 'Understood'
    },
    search: {
        'header': 'Recently Searched',
        'hot_header': 'Popular Searches',
        'placeholder': 'Please Enter Keywords',
        'cancel': 'Cancel',
        'keyword_empty': 'Please Enter The Keywords You Look For'
    }
}



// WEBPACK FOOTER //
// ./src/assets/i18n/en_us.js